import { Paper, PaperProps, useTheme } from '@mui/material';
import React, { forwardRef } from 'react';

const LayoutContainer = forwardRef<HTMLDivElement, PaperProps>(
	({ sx, ...props }, ref) => {
		const theme = useTheme();
		return (
			<Paper
				ref={ref}
				elevation={0}
				sx={{
					backgroundColor: theme.palette.mainPaperBackground,
					...sx
				}}
				{...props}
			/>
		);
	}
);

export default LayoutContainer;
